import { render, staticRenderFns } from "./TraffictViolationAdd.vue?vue&type=template&id=ea105072&scoped=true"
import script from "./TraffictViolationAdd.vue?vue&type=script&lang=js"
export * from "./TraffictViolationAdd.vue?vue&type=script&lang=js"
import style0 from "./TraffictViolationAdd.vue?vue&type=style&index=0&id=ea105072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea105072",
  null
  
)

export default component.exports